import * as React from 'react';
import { Form, Table } from '../../components';
import ApiService from '../../services/api.service';
import AppService from '../../services/app.service';

interface IProps { 
  history?: any;
  id?: any;
  parentId?: number; //for nested list, need parent id to filling default value (eg. transaction Id)
  caption?: string;
  captionColor?: any;
  captionThin?: boolean;
  nodataCaption ?: string;
  endPointFilter?: string;
  model: any;
  header?: any;
  url?: string;
  onLoad?: (data: any) => void;
  onLoadAll?: (data: any, page?: any) => any;
  page?: number;
  pageSize?: number;
  searchField?: string;
  onChangePage?: (value: number) => void;
  actions?: any;
  cardColor?: any;
  cardGradientColor?: any;
  readOnly?: boolean;
  disableView?: boolean;
  disableCaptionSuffix?: boolean;
  disableBackButton?: boolean;
  disableCard? : boolean;
}

interface IState {
  dataset: Array<any>;
  header: Array<any>;
  endPointFilter: string;
  parentId: number;
  page: number;
  pageSize: number;
  pageCount: number;
  pageName: string;
  actions: any;
  searchText: string;
  isSearch: boolean;
  isReady: boolean;
  isError: boolean;
  readOnly?: boolean;
}

export default class BaseList extends React.Component<IProps, IState> {
  
  constructor(props: IProps) {
    super(props);
    this.state = {
      dataset: [],
      header: this.header(),
      endPointFilter: this.props.endPointFilter || '',
      parentId: this.props.parentId || 0,
      page: this.props.page || 1,
      pageSize: this.props.pageSize || 10,
      pageCount: 0,
      pageName: this.props.model.url.replace('/','') + (this.props.id || '') + 'Page',
      actions: this.actions(),
      searchText: '',
      isSearch: this.props.model.columns?.findIndex((d: { name: string; }) => d.name === (this.props.searchField || 'name'))>=0,
      isReady: false,
      isError: false,
    }
    
    this.onChangePage = this.onChangePage.bind(this);
    this.onChangeSearch = this.onChangeSearch.bind(this);
    this.onClickSearch = this.onClickSearch.bind(this);
    this.onEndTypingSearch = this.onEndTypingSearch.bind(this);
  }
  
  private historyState: any = this.props.history?.location.state;
  private isLoading: boolean = false;

  private header() {
    return this.props.header || this.props.model.columns;
  }

  private loadData (page: number, searchText?: string) {
    if (this.isLoading) return;
    this.isLoading = true;
    this.setState({ isReady: false});
    
    const paginationPage = '&pagination[page]=' + page;
    const paginationPageSize = '&pagination[pageSize]=' + this.state.pageSize;
    const search = searchText? '&filters[' + (this.props.searchField || 'name') + '][$contains]=' + searchText : paginationPage;
    
    ApiService.getAll<typeof this.props.model>(this.props.model.endPoint + (this.props.endPointFilter || '?populate=*') + search + paginationPageSize)
    .then(rp => {
      if (rp.Status) {
        const pageCount = Math.ceil((rp.Meta?.pagination?.total || 1) / this.state.pageSize);
        const dataset = rp.Data?.map((d: any) => new this.props.model(d));
        var loadAll = this.props.onLoadAll?.(dataset, rp.Meta.pagination);
        this.setState({ dataset: loadAll?.dataset || dataset, pageCount: pageCount, pageSize: loadAll?.pageSize || this.state.pageSize, isReady: true });

      } 
      else { this.setState({ isReady: true, isError: true }); }
      this.isLoading = false;
    });
  }

  private actions = (id?: number) => {
    const url = this.props.url + '/';
    const actionList = [
      {id: 'create', caption: 'Create', icon:'add', url: url+ 'create', state: {id: this.props.parentId}}, 
      {id: 'copy', caption: 'Duplicate', icon:'queue_outlined', url: id && url+ 'copy', state: {id: id}}, 
      {id: 'view', caption: 'View', icon:'segment', url: id && url+ 'view', state: {id: id}}, 
      {id: 'edit', caption: 'Edit', icon:'drive_file_rename_outline', url: id && url+ 'edit', state: {id: id}}, 
      {id: 'status', caption: 'Change Status', icon:'verified_user', url: id && url+ 'status', state: {id: id}}, 
      {id: 'preview', caption: 'Preview', icon:'find_in_page', url: id && this.props.actions && url+ 'preview', state: {id: id, parentId: this.state?.parentId}}, 
      {id: 'share', caption: 'Share', icon:'share', url: id && url+ 'share', state: {id: id}}, 
      {id: 'delete', caption: 'Delete', icon:'delete', color:'error', url: id && url+ 'delete', state: {id: id}}, 
    ];

    const actionDefault = (!this.props.actions || this.props.actions?.includes('...'))? ['create', 'copy', 'view', 'edit', 'delete'] : [];

    return actionList.filter((d: any) => 
      (actionDefault.includes(d.id)  || this.props.actions?.includes(d.id))
    );
  }

  private onLoad = (data: any) => {
    const actions = this.actions(data.id);
    
    if (actions.length === 1 && actions[0].url) this.props.history?.push(actions[0].url, {...this.historyState, ...actions[0].state});
    this.props.onLoad?.(data);
    this.setState({ actions: actions});
  }

  private onChangePage (value: number) {
    AppService.historyState(this.state.pageName, value);
    this.setState({page: value});
    this.loadData(value, this.state.searchText);
    this.props.onChangePage?.(value)
  }
  
  private onChangeSearch(fieldName: string, value?: string) { 
    this.setState({searchText: value || ''});
    if (!value) this.loadData(this.state.page, value);
  }
  
  private onClickSearch() { 
    this.loadData(this.state.page, this.state.searchText);
  }

  private onClickCreate = (data: any) => { 
    this.props.history?.push(data.url, data.state)
  }

  private onEndTypingSearch(fieldName?: string, value?: string) {
    this.setState({searchText: value || ''});
    this.loadData(this.state.page, value);
  }

  private table(){
    return <Table history={this.props.history} header={this.state.header} dataset={this.state.dataset} nodataCaption ={this.props.nodataCaption } page={this.state.page} pageCount={this.state.pageCount} actions={this.state.actions} searchText={this.state.searchText} isSearch={this.state.isSearch} isLoading={this.isLoading} isReady={this.state.isReady} isError={this.state.isError} onLoad={this.onLoad} onChangePage={this.onChangePage} onChangeSearch={this.onChangeSearch} onClickSearch={this.onClickSearch} onClickCreate={this.onClickCreate} onEndTypingSearch={this.onEndTypingSearch} readOnly={this.props.readOnly} />
  }

  public componentDidMount() {
    const page = this.historyState?.[this.state.pageName] || this.state.page;
    this.loadData(page);
    this.setState({page: page})
  }

  public componentDidUpdate() {
    if (this.header() !== this.state.header)
      this.setState({ header: this.header()});

    if (!this.isLoading)
      if (this.props.page && (this.props.page !== this.state.page)) {
        this.setState({page: this.props.page})
        this.loadData(this.props.page, this.state.searchText);
      }
      else if (this.props.endPointFilter && (this.props.endPointFilter !== this.state.endPointFilter)) {
        this.setState({endPointFilter: this.props.endPointFilter})
        this.loadData(1);
      }
  }

  public render(): React.ReactNode {  
    var caption = (this.props.caption || this.props.model.caption).trim();
    if (!this.props.disableCaptionSuffix && caption) caption = AppService.strPluralize(caption);
    
    return (
      <Form history={this.props.history} caption={caption} captionColor={this.props.captionColor} captionThin={this.props.captionThin} buttonCaption=' ' cardColor={this.props.cardColor} cardGradientColor={this.props.cardGradientColor} disableBackButton={this.props.disableBackButton} disableCard={this.props.disableCard}>              
          {!this.props.disableView && this.table()}
      </Form> 
    );
  }
}
